interface DurationInputProps {
  duration: number;
  disabled: boolean;
  onChange: (value: string) => void;
  onBlur: () => void;
}

export const DurationInput: React.FC<DurationInputProps> = ({
  duration,
  disabled,
  onChange,
  onBlur
}) => (
  <div className="flex-1 aspect-square bg-gradient-to-br bg-[#dfdfdf] rounded border border-[#46494c] py-2">
    <div className="flex justify-center text-xs text-black mb-1">DURATION</div>
    <div className="flex flex-col items-center">
      <input
        type="text"
        value={duration}
        onChange={(e) => !disabled && onChange(e.target.value)}
        onBlur={onBlur}
        className={`w-16 text-center text-[2.4rem] bg-[#dfdfdf] ${disabled ? 'text-gray-400 cursor-not-allowed' : 'text-black cursor-text'
          }`}
        style={{ lineHeight: 'normal' }}
        disabled={disabled}
      />
    </div>
  </div>
); 